export class Async {
	static image(src, callback) {
		const img = new Image();
		let url = src;

		if (callback) {
			img.onload = function () {
				callback(img);
			};
		}

		img.src = url;
	}
}
